var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toolView"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"caseName"},[_vm._v(_vm._s(_vm.collectionName))]),_c('div',{staticClass:"cite",on:{"click":_vm.goto}},[_vm._v("全部引用")])]),_c('div',{staticClass:"chat-container"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.mdToHtml(_vm.getMsg(this.message)))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }